import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

import t from '../../../lib/I18n';
import connectToStores from '../../../helpers/connectToStores';

import { AmazonLoginCTATypes, AmazonLoginStatus, BAlertTypes } from '../../../constants/AppConstants';
import AmazonLoginStore from '../../../stores/AmazonLoginStore';
import AmazonLogin from './AmazonLogin';
import BAlert from '../../general/BAlert';
import FeatureFlagStore from '../../../stores/FeatureFlagStore';

const _getStateFromStores = () => ({
    enableAmazonLogin: FeatureFlagStore.get('enableAmazonLogin'),
    enableAmazonRegistration: FeatureFlagStore.get('enableAmazonRegistration'),
    error: AmazonLoginStore.getStatus() === AmazonLoginStatus.LOGIN_ERROR
});

const AmazonLoginCTA = ({ closeModal, enableAmazonLogin, enableAmazonRegistration, error, isVertical, onButtonClick, type }) => {
    const isEnabled = enableAmazonLogin && (type !== AmazonLoginCTATypes.REGISTER || enableAmazonRegistration);

    if (!isEnabled) {
        return null;
    }

    return (
        <React.Fragment>
            <div className="amazon-login__cta-wrapper">
                { error && <BAlert type={ BAlertTypes.DANGER } className="margin-bottom--sm">
                    { t('login.amazon.error') }
                </BAlert >}
                <div className={ classnames('amazon-login__cta', { 'amazon-login__cta--vertical': isVertical }) }>
                    <div className="amazon-login__cta__text">
                        <h4 className="amazon-login__cta__text__top">{ t('account.register.cta.side', { brand: t('app.owner.short') }) }</h4>
                        <h3 className="amazon-login__cta__text__bottom">{ t('account.register.cta.main') }</h3>
                    </div>
                    <div className="amazon-login__cta__button">
                        <AmazonLogin
                            onButtonClick={ onButtonClick }
                            closeModal={ closeModal }
                            hideErrors
                            isAlreadyRegistering
                            isLongButton={ isVertical }
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

AmazonLoginCTA.propTypes = {
    closeModal: PropTypes.func.isRequired,
    enableAmazonLogin: PropTypes.bool,
    enableAmazonRegistration: PropTypes.bool,
    error: PropTypes.bool.isRequired,
    isVertical: PropTypes.bool,
    onButtonClick: PropTypes.func,
    type: PropTypes.string,
};

AmazonLoginCTA.defaultProps = {
    enableAmazonLogin: false,
    enableAmazonRegistration: false,
    type: AmazonLoginCTATypes.LOGIN,
    isVertical: false,
    onButtonClick: _.noop,
};

export default connectToStores([AmazonLoginStore, FeatureFlagStore], _getStateFromStores)(AmazonLoginCTA);



// WEBPACK FOOTER //
// ./src/components/login/amazon/AmazonLoginCTA.js